import { useState } from "react";
import { DatabaseZap, X } from "lucide-react";

export const RecorderHealthBanner = ({ health, onGoBacktest }) => {
  const [, force] = useState(0);
  const bad = health?.last_day && health.last_day.status !== "ok" ? health.last_day : null;
  const key = bad && `orb-recorder-health-dismissed-${bad.date}`;
  if (!bad || localStorage.getItem(key)) return null;
  return (
    <div data-testid="banner-recorder-health" className="flex flex-wrap items-center gap-2 border-t border-amber-500/30 bg-amber-500/10 px-3 py-2 text-xs text-amber-300 sm:px-4">
      <DatabaseZap size={14} />
      <span>
        <b>Option recorder {bad.status === "missed" ? "saved nothing" : "saved too few snapshots"} on {bad.date}</b> ({bad.count} of ~{health.expected_per_day} expected).
        {" "}That day {bad.status === "missed" ? "won't count (unless it was a market holiday)" : "may be thin"} toward the 15-day real-price history. Keep the app running 9:15–15:30 with a valid Dhan token.
      </span>
      <span className="ml-auto flex items-center gap-3">
        <button data-testid="button-recorder-health-details" onClick={onGoBacktest} className="underline underline-offset-2">Details</button>
        <button data-testid="button-dismiss-recorder-health" aria-label="Dismiss" onClick={() => { localStorage.setItem(key, "1"); force((n) => n + 1); }}><X size={13} /></button>
      </span>
    </div>
  );
};
